import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DocumentService } from '../../../core/services/DocumentService';

@Component({
  selector: 'app-login-qr-code',
  templateUrl: './login-qr-code.component.html',
  styleUrls: ['./login-qr-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class LoginQrCodeComponent implements OnChanges {
  @Input() badgeSvg: string | null = null;
  @Input() userLabel = '';
  @Input() documentKey: string | null = null;

  safeSvg: SafeHtml | null = null;

  constructor(
    private readonly _sanitizer: DomSanitizer,
    private readonly _documentService: DocumentService,
  ) {}

  ngOnChanges(): void {
    this.safeSvg = this.badgeSvg
      ? this._sanitizer.bypassSecurityTrustHtml(this.badgeSvg)
      : null;
  }

  print(): void {
    if (!this.documentKey) {
      return;
    }

    window.open(this._documentService.getDownloadUrl(this.documentKey), '_blank');
  }
}
